<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!solicitacoesCancelamento || !solicitacoesCancelamento.length">
      Não foram encontradas solicitações de cancelamento com os filtros informados.
    </div>

    <div class="row" *ngIf="solicitacoesCancelamento && solicitacoesCancelamento.length">
      <div *ngIf="mostrarExportarSolicitacoesCancelamento">
        <button  class="btn btn-secondary float-end" type="button" (click)="exportarSolicitacoesCancelamento()"
          placement="top" ngbTooltip="Exporta todas as solicitações de cancelamento listadas">
        <i class="fa fa-file"></i> Exportar Solicitações de Cancelamento</button>
      </div>
      <bn-paginacao [total]="atributosPaginacao.count"
        [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
        [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th id="col-agente" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'"
                    [nomeAtributoExibicao]="'ID'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-id-operacao-externo" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoExterno'"
                    [nomeAtributoExibicao]="'Id. ext. operação'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-contrato" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'"
                    [nomeAtributoExibicao]="'Sist./Contrato'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-data-envio" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'"
                    [nomeAtributoExibicao]="'Data de envio'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
               
                <th id="col-estado" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'estado'" [nomeAtributoExibicao]="'Estado'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-Multa" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'multa'" [nomeAtributoExibicao]="'Multa'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th scope="col"></th> <!--lupa para visualizar os detalhes-->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cancelamento of solicitacoesCancelamento" id="pointer" [routerLink]="['/cancelamento/cadastro', cancelamento.id]">
                <td>{{ cancelamento.id }}</td>
                <td *ngIf="!ehAgenteFinanceiro" >{{ nomeAgente(cancelamento.cnpjAgenteFinanceiro) }}</td>                
                <td>{{ cancelamento.idOperacaoExterno }}</td>
                <td>{{ cancelamento.contratoRepasse ? cancelamento.sistemaRepasse + '/' + cancelamento.contratoRepasse : ''}}</td>
                <td>{{ cancelamento.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td>{{ cancelamento.estado.nomeEstado }}</td>
                <td>{{ cancelamento.valorPercentualMulta && cancelamento.valorPercentualMulta > 0 ? 'Sim' : 'Não' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </bn-paginacao>
    </div>
  </div>